﻿"use strict";

//  is removed for PROD and a number for DEBUG so that functions can run side-by-side.

/* eslint-disable @typescript-eslint/no-unused-vars */
/* global console setInterval, clearInterval */

console.log("Loading custom functions from custom.js");

let customFunctionService = null;

// Receive the .NET object reference
function setCustomFunctionService(reference) {
    customFunctionService = reference;
    console.log("customFunctionService reference received.");
}

/**
 * Gets a list of LemonEdge entity types
 * @customfunction GETMETADATA
 * @param {boolean} [includeHeaders] Whether to include the headers in the results. If omitted, includeHeaders = false.
 * @returns {string[][]} A list of entity types.
 */
async function getMetaData(includeHeaders) {
    try {
        return await customFunctionService.invokeMethodAsync("GetMetaData", includeHeaders ?? false);
    } catch (error) {
        return handleError(error);
    }
}
CustomFunctions.associate("GetMetaData", getMetaData);

/**
 * Retrieves data from a C# backend service for OData queries.
 * @customfunction GETODATA
 * @param {string} type The entity type to query (e.g., "Products", "Orders").
 * @param {boolean} [includeHeaders] Whether to include the headers in the results. If omitted, includeHeaders = false.
 * @param {string} [select] The fields to select, separated by commas (e.g., "Name,Price"). If ommitted, returns all.
 * @param {string} [filter] An optional OData filter expression to apply (e.g., "Price gt 20"). If ommitted, returns all.
 * @param {string} [orderby] An optional OData order by expression (e.g., "Name asc"). If ommitted, returns default.
 * @param {number} [count] An optional maximum number of results to retrieve. If ommitted, returns 500.
 * @returns {any[][]} The result set as a two-dimensional array.
 */
async function getOData(type, includeHeaders, select, filter, orderby, count) {
    try {
        return await customFunctionService.invokeMethodAsync("GetOData", type, includeHeaders ?? false, select, filter, orderby, count);
    } catch (error) {
        return handleError(error);
    }
}
CustomFunctions.associate("GetOData", getOData);

/**
 * Gets the parameter list for a query.
 * @customfunction GETQUERYPARAMETERS
 * @param {string} id The query id (GUID), or friendly name (takes the first if multiple found).
 * @param {boolean} [includeHeaders] Whether to include the headers in the results. If omitted, includeHeaders = false.
 * @param {boolean} [includeDefaults] Whether to include the default parameter set. If omitted, initialised as per platform settings.
 * @param {string} [selectHeaders] The fields to select, separated by commas (e.g., "Name,Price"). If ommitted, returns all.
 * @returns {any[][]} A list of entity types.
 */
async function getQueryParameters(id, includeHeaders, includeDefaults, selectHeaders) {
    try {
        return await customFunctionService.invokeMethodAsync("GetQueryParameters", id, includeHeaders ?? false, includeDefaults ?? false, selectHeaders);
    } catch (error) {
        return handleError(error);
        //debugger;
        //throw new CustomFunctionRuntime.error(CustomFunctionRuntime.ErrorType.invalidNumber, error.message || "An unexpected error occurred while fetching entity types.");
        ///*throw new CustomFunctions.error(CustomFunctions.errorType.invalidNumber, error.message || "An unexpected error occurred while fetching entity types.");*/
    }
}
CustomFunctions.associate("GetQueryParameters", getQueryParameters);

/**
 * Gets the parameter list for a query.
 * @customfunction QUERY
 * @param {string} id The query id (GUID), or friendly name (takes the first if multiple found).
 * @param {boolean} [includeHeaders] Whether to include the headers in the results. If omitted, includeHeaders = false.
 * @param {string} [selectHeaders] The fields to select, separated by commas (e.g., "Name,Price"). If ommitted, returns all.
 * @param {any[][][]} [args] The argument list - either the values mapped to the getQueryParameter list, or an explicit range defining names and values (as per the getQueryParameter output).
 * @returns {any[][]} The result set.
 */
async function query(id, includeHeaders, selectHeaders, args) {
    try {
        return await customFunctionService.invokeMethodAsync("Query", id, includeHeaders ?? false, selectHeaders, false, args);
    } catch (error) {
        return handleError(error);
    }
}
CustomFunctions.associate("Query", query);

/**
 * Gets the parameter list for a query.
 * @customfunction QUERYTASK
 * @param {string} id The query id (GUID), or friendly name (takes the first if multiple found).
 * @param {boolean} [includeHeaders] Whether to include the headers in the results. If omitted, includeHeaders = false.
 * @param {string} [selectHeaders] The fields to select, separated by commas (e.g., "Name,Price"). If ommitted, returns all.
 * @param {any[][][]} [args] The argument list - either the values mapped to the getQueryParameter list, or an explicit range defining names and values (as per the getQueryParameter output).
 * @returns {any[][]} The result set.
 */
async function queryTask(id, includeHeaders, selectHeaders, args) {
    try {
        return await customFunctionService.invokeMethodAsync("Query", id, includeHeaders ?? false, selectHeaders, true, args);
    } catch (error) {
        return handleError(error);
    }
}
CustomFunctions.associate("QueryTask", queryTask);

function handleError(error) {
    return new CustomFunctions.Error(CustomFunctions.ErrorCode.invalidValue, error.message || "An unexpected error occurred while fetching entity types.");
}

// This still converts to a string - leaving here for reference.
function validArray(data) {
    if (!Array.isArray(data)) return data; // If it's not an array, return as is

    return data.map(row =>
        row.map(cell => {
            if (typeof cell === "string" && isValidDateString(cell)) {
                return new Date(cell);
            }
            return cell;
        })
    );
}

function isValidDateString(str) {
    return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{1,7})?([+-]\d{2}:\d{2}|Z)?$/.test(str);
}